// Developer tuning overlay. Toggle with the backslash `\` key. Shows live sim
// readouts (heat, toastedness, distance, dt, flame intensity, score) so balance
// constants can be dialed in by eye. Hidden by default; zero gameplay effect.

import Phaser from 'phaser';

export interface DebugInfo {
  heat: number;
  toastedness: number;
  distance: number;
  dt: number;
  flameIntensity: number;
  bandMin: number;
  bandMax: number;
  score: number;
  fps: number;
}

export class DebugOverlay {
  private text: Phaser.GameObjects.Text;
  private visible = false;

  constructor(scene: Phaser.Scene) {
    this.text = scene.add
      .text(16, 80, '', {
        fontFamily: 'monospace',
        fontSize: '13px',
        color: '#9fe87a',
        backgroundColor: '#000000aa',
        padding: { x: 6, y: 4 },
      })
      .setScrollFactor(0)
      .setDepth(100)
      .setVisible(false);

    scene.input.keyboard?.on('keydown-BACKSLASH', () => {
      this.visible = !this.visible;
      this.text.setVisible(this.visible);
    });
  }

  update(info: DebugInfo): void {
    if (!this.visible) return;
    this.text.setText(
      [
        `fps   ${info.fps.toFixed(0)}   dt ${(info.dt * 1000).toFixed(1)}ms`,
        `heat  ${info.heat.toFixed(1)}`,
        `toast ${info.toastedness.toFixed(1)}`,
        `dist  ${info.distance.toFixed(3)}`,
        `flame ${info.flameIntensity.toFixed(1)}`,
        `band  [${info.bandMin.toFixed(1)}, ${info.bandMax.toFixed(1)}]`,
        `score ${info.score}`,
      ].join('\n'),
    );
  }

  destroy(): void {
    this.text.destroy();
  }
}
